/**
 * Proficiency level utilities for skill visualization
 */

export const PROFICIENCY_LEVELS = {
  EXPERT: 'Expert',
  ADVANCED: 'Advanced',
  INTERMEDIATE: 'Intermediate',
  BEGINNER: 'Beginner',
};

/**
 * Returns the Tailwind background color class for a proficiency level
 * @param {string} level - The proficiency level
 * @returns {string} Tailwind CSS class for background color
 */
export const getProficiencyColor = (level) => {
  switch (level) {
    case PROFICIENCY_LEVELS.EXPERT:
      return 'bg-green-500';
    case PROFICIENCY_LEVELS.ADVANCED:
      return 'bg-blue-500';
    case PROFICIENCY_LEVELS.INTERMEDIATE:
      return 'bg-yellow-500';
    case PROFICIENCY_LEVELS.BEGINNER:
      return 'bg-gray-400';
    default:
      return 'bg-gray-300';
  }
};

/**
 * Returns the Tailwind width class for a proficiency level progress bar
 * @param {string} level - The proficiency level
 * @returns {string} Tailwind CSS class for width
 */
export const getProficiencyWidth = (level) => {
  switch (level) {
    case PROFICIENCY_LEVELS.EXPERT:
      return 'w-full';
    case PROFICIENCY_LEVELS.ADVANCED:
      return 'w-4/5';
    case PROFICIENCY_LEVELS.INTERMEDIATE:
      return 'w-3/5';
    case PROFICIENCY_LEVELS.BEGINNER:
      return 'w-2/5';
    default:
      return 'w-1/5';
  }
};

/**
 * Returns numeric percentage for a proficiency level
 * @param {string} level - The proficiency level
 * @returns {number} Percentage value (0-100)
 */
export const getProficiencyPercentage = (level) => {
  switch (level) {
    case PROFICIENCY_LEVELS.EXPERT:
      return 100;
    case PROFICIENCY_LEVELS.ADVANCED:
      return 80;
    case PROFICIENCY_LEVELS.INTERMEDIATE:
      return 60;
    case PROFICIENCY_LEVELS.BEGINNER:
      return 40;
    default:
      return 20;
  }
};
